// F3/FR-SH5a: the calm "gone" screen for a share link that is unknown, revoked, expired, or
// over its view limit — `server/src/error.rs`'s `ApiError::LinkUnavailable` (410) is
// byte-identical for all four causes, so this page never tries to say which one it was.
// Same shell as NotFound — a different, link-specific sentence rather than a new layout.
import { NoAccessShell } from "../components/NoAccessShell";

export default function LinkUnavailable() {
  return (
    <NoAccessShell icon="calendar-x" title="This link is no longer available">
      <p>
        It may have been revoked, expired, or reached its view limit. The recording itself may still exist — ask whoever
        shared it for a new link.
      </p>
    </NoAccessShell>
  );
}
